__turbopack_context__.v({
  "profile-dropdown-client": "iEMXYW_profile-dropdown-client",
  "profile-dropdown-client__content": "iEMXYW_profile-dropdown-client__content",
  "profile-dropdown-client__popover": "iEMXYW_profile-dropdown-client__popover",
  "profile-dropdown-client__trigger": "iEMXYW_profile-dropdown-client__trigger",
  "slide-in": "iEMXYW_slide-in",
  "slide-out": "iEMXYW_slide-out",
});
